import React, { ReactElement } from 'react';
import Prompt from './Shared/Prompt';
import QuestionWrapper from './Shared/QuestionWrapper';

interface ITextBlock {
  index: number;
  prompt: string;
}

const TextBlock = ({ index, prompt }: ITextBlock): ReactElement => {
  return (
    <QuestionWrapper index={index}>
      <Prompt prompt={prompt} isRequired={false} isTextBlock />
    </QuestionWrapper>
  );
};

export default TextBlock;
